<template>
  <div>
    <div class="tabs is-boxed">
        <ul>
            <router-link :to="{ name: 'client-settings-general' }" active-class="is-active" tag="li" exact><a>General</a></router-link>
            <router-link :to="{ name: 'client-settings-game-proviers' }" active-class="is-active" tag="li"><a>Game providers</a></router-link>
            <router-link :to="{ name: 'client-settings-registration' }" active-class="is-active" tag="li"><a>Registration</a></router-link>
            <router-link :to="{ name: 'client-settings-login' }" active-class="is-active" tag="li"><a>Login</a></router-link>
            <router-link :to="{ name: 'client-settings-messengers' }" active-class="is-active" tag="li"><a>Messengers</a></router-link>
            <router-link :to="{ name: 'client-settings-bonuses' }" active-class="is-active" tag="li"><a>Bonuses settings</a></router-link>
            <router-link :to="{ name: 'client-settings-curacao' }" active-class="is-active" tag="li"><a>Curacao</a></router-link>
            <router-link :to="{ name: 'client-settings-kra' }" active-class="is-active"><a>KRA</a></router-link>
            <router-link :to="{ name: 'client-settings-support' }" active-class="is-active" tag="li"><a>Support</a></router-link>
            <router-link :to="{ name: 'client-settings-payment-system' }" active-class="is-active" tag="li"><a>Payments settings</a></router-link>
            <router-link :to="{ name: 'client-settings-komplexbridge' }" active-class="is-active" tag="li"><a>KomplexBridge</a></router-link>
            <router-link :to="{ name: 'client-settings-view' }" active-class="is-active" tag="li"><a>View</a></router-link>
            <router-link :to="{ name: 'client-settings-winning-stats' }" active-class="is-active" tag="li"><a>Winning stats</a></router-link>
            <router-link :to="{ name: 'client-settings-mpesa' }" active-class="is-active" tag="li"><a>Mpesa</a></router-link>
            <router-link :to="{ name: 'client-settings-gcb' }" active-class="is-active" tag="li"><a>GCB</a></router-link>
            <router-link :to="{ name: 'client-settings-referral' }" active-class="is-active" tag="li"><a>Referral</a></router-link>
            <router-link :to="{ name: 'client-settings-taxes' }" active-class="is-active" tag="li"><a>Taxes</a></router-link>
            <router-link :to="{ name: 'client-settings-ussd' }" active-class="is-active" tag="li"><a>Ussd</a></router-link>
        </ul>
    </div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'client-settings'
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/index.vue